import React, { useState } from "react";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,   FirstAds,MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Daily Water Intake Calculator";
const DESCRIPTION =
  "The daily water intake calculator helps you determine the right amount of water you should drink daily based on your weight, activity level, and the climate you live in.";
const KEYWORDS =
  "water intake calculator, drinking water, body health, daily water needs";
const OG_URL =
  "https://do-calculate.com/calculator/en/water-intake-calculator/";
function WaterIntakeCalculator() {
  const [weight, setWeight] = useState("");
  const [activityLevel, setActivityLevel] = useState("low");
  const [climate, setClimate] = useState("moderate");
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const handleWeightChange = (event) => {
    setWeight(event.target.value);
  };
  const handleActivityLevelChange = (event) => {
    setActivityLevel(event.target.value);
  };
  const handleClimateChange = (event) => {
    setClimate(event.target.value);
  };
  const calculateWaterIntake = () => {
    const weightNum = parseFloat(weight);
    if (isNaN(weightNum) || weightNum <= 0) {
      setError("Please enter a valid weight");
      setResult(null);
      return;
    }
    let baseIntake = weightNum * 0.033;
    if (activityLevel === "moderate") {
      baseIntake *= 1.2;
    } else if (activityLevel === "high") {
      baseIntake *= 1.4;
    }
    if (climate === "hot") {
      baseIntake *= 1.3;
    } else if (climate === "cold") {
      baseIntake *= 0.9;
    }
    setResult(baseIntake.toFixed(2));
    setError(null);
  };
  return (
    <div>
        <SharedHelmet
             TITLE={TITLE}
             DESCRIPTION={DESCRIPTION}
             KEYWORDS={KEYWORDS}
             OG_URL={OG_URL}
           />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "39px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  The daily water intake calculator helps you determine the
                  right amount of water you should drink daily based on your
                  weight, activity level, and the climate you live in. This
                  calculator can help you maintain your hydration and overall
                  health.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-4">
                <img
                  src="/water-intake.png"
                  alt="Water Intake Illustration"
                  style={{ width: "100%", paddingTop: "100px" }}
                />
              </div>
              <div className="col-sm-12 col-md-4 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  Daily Water Intake Calculator
                </div>
                <hr />
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="weight" className="form-label ms-2">
                      Weight (kg)
                    </label>
                  </b>
                  <input
                    type="number"
                    id="weight"
                    value={weight}
                    onChange={handleWeightChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                    placeholder="kg"
                  />
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="activityLevel" className="form-label ms-2">
                      Activity Level
                    </label>
                  </b>
                  <select
                    id="activityLevel"
                    value={activityLevel}
                    onChange={handleActivityLevelChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                  >
                    <option value="low">Low</option>
                    <option value="moderate">Moderate</option>
                    <option value="high">High</option>
                  </select>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="climate" className="form-label ms-2">
                      Climate
                    </label>
                  </b>
                  <select
                    id="climate"
                    value={climate}
                    onChange={handleClimateChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                  >
                    <option value="moderate">Moderate</option>
                    <option value="hot">Hot</option>
                    <option value="cold">Cold</option>
                  </select>
                </div>
                <br />
                <hr />
                <div>
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                    onClick={calculateWaterIntake}
                  >
                    Calculate                  </button>
                </div>
              </div>
              <div className="col-sm-12 col-md-4">
                <div>
                  { error && (
                    <div className="alert alert-warning">
                      <b>
                        <u>Error:</u>
                      </b>{" "}
                      {error}
                    </div>
                  )}
                  { result && (
                    <div>
                      <h4>Result:</h4>
                      <hr />
                      <div
                        style={{
                          backgroundColor: "#D1E7DD",
                          borderColor: "#c3e6cb",
                          color: "#155724",
                          padding: "15px",
                          marginBottom: "20px",
                          borderRadius: "4px",
                        }}
                      >
                        <p>
                          The recommended daily water intake is: {result} liters
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <hr />
                <div className="row">
                  <RelatedLinks />
                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br/>        </div>
      </div>
      <hr />
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                How to use the Daily Water Intake Calculator?
              </div>
              <div className="info-section-body">
                <p>
                  To use the daily water intake calculator, enter your weight in
                  kilograms, select your activity level and the climate you live
                  in. Click the "Calculate" button to get the recommended daily
                  water intake.
                </p>
              </div>
            </div>
          </div>
          <br />
          <u>
            <h2>Frequently Asked Questions</h2>
          </u>
          <br />
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  What is the Daily Water Intake Calculator?
                </h3>
              </div>
              <div className="info-section-body">
                <p>
                  The daily water intake calculator helps you determine the
                  right amount of water you should drink daily based on your
                  weight, activity level, and the climate you live in.
                </p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Why is it important to drink enough water?
                </h3>
              </div>
              <div className="info-section-body">
                <p>
                  Drinking enough water is important for maintaining vital body
                  functions, such as regulating temperature, removing waste, and
                  keeping the skin hydrated. Dehydration can lead to serious
                  health problems.
                </p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  How do activity level and climate affect water needs?
                </h3>
              </div>
              <div className="info-section-body">
                <p>
                  Physical activity increases water loss through sweat, which
                  increases water needs. Similarly, hot climates can increase
                  water loss, while you may need less water in cold climates.
                </p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Can you drink too much water?
                </h3>
              </div>
              <div className="info-section-body">
                <p>
                  Yes, drinking too much water can lead to a condition called
                  water intoxication, where the salts in the body are
                  excessively diluted. It's important to drink enough water
                  without overdoing it.
                </p>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default WaterIntakeCalculator;
